import React, { useState } from "react";
import pictureOne from "./assets/picOne.png";

const StandardsServices = () => {
  const [popup, setPopup] = useState({ show: false, type: "" });
  const [showPdf, setShowPdf] = useState(false);

  const openPopup = (type) => setPopup({ show: true, type });
  const closePopup = () => setPopup({ show: false, type: "" });

  const getPopupContent = () => {
    if (popup.type === "mbsBoard") {
      return {
        heading: "MBS Board",
        body: `As a Government Agency established by an Act of Parliament, and responsible for promoting standardization and quality assurance, the MBS is governed by the MBS Board that is appointed by Government (Section 7 - 17 of the MBS Act). The Board is responsible for the operations of the MBS subject to special and general direction of the responsible Minister.`
      };
    } else if (popup.type === "sqamCommittee") {
      return {
        heading: "Standardization, Quality Assurance and Metrology Committee",
        body: `Section 16(1) of the MBS Act mandates the MBS Board that for the purposes of performing its functions under the Act, it may establish Committees and delegate to any such Committee such functions of the Board as the Board may consider expedient. In line with this provision, the MBS Board established the Standardization, Quality Assurance, Accreditation and Metrology Committee with the main purpose of reviewing the performance of technical departments of the MBS, and advising the Board on the same. This includes review of the draft standards development through various TCs and recommending these for approval to the MBS Board.`
      };
    }
    return { heading: "", body: "" };
  };

  const content = getPopupContent();

  return (
    <div className="about-us">

      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Development of Malawi Standards</h1>
          <p className="subtitle">
            Promoting standardization and quality assurance in Malawi. Ensuring stakeholder participation and compliance with international best practices.
          </p>
        </div>
      </section>

      {/* === Development of Malawi Standards Section === */}
      <section className="what-section">
        <p>
          The development of a Malawi standard begins after a new work item proposal has been received by the MBS. 
          The proposal for a new work item can come from any stakeholder (industry, Government, academia, the general public (consumers), or from within the MBS). 
          The proposal may be a project for either a new standard or the revision of an existing standard. Proposals can be submitted using the following forms:
        </p> 
        <ul>
          <li><span style={{ color: "red", cursor: "pointer" }}>Proposal for a new standard</span></li>
          <li><span style={{ color: "red", cursor: "pointer" }}>Proposal to review an existing standard</span></li>
        </ul>
        <p>
          Once a proposal is received and approved, the Secretariat of an appropriate Technical Committee (TC) 
          develops a draft proposal (draft standard) for consideration by the appropriate TC. The drafting of the proposal is based on existing international standards, regional standards, or other foreign national standards, as appropriate, with international standards being the first priority.
        </p>
        <p>
          After consideration by the appropriate TC, draft standards that are intended to be enforced as mandatory/compulsory are circulated for public review or notified to the World Trade Organization for a period of 60 days. 
          Upon consideration of the comments received from the public review process, the draft standard is submitted to the <span onClick={() => openPopup("mbsBoard")} style={{ color: "red", textDecoration: "none", cursor: "pointer" }}>MBS Board</span> for approval, through the <span onClick={() => openPopup("sqamCommittee")} style={{ color: "red", textDecoration: "none", cursor: "pointer" }}>Standardization, Quality Assurance and Metrology (SQAM) Committee</span> of the MBS Board. 
          Upon approval by the MBS Board, the standard is submitted for gazetting in the Government Gazette. 
          This is a diagrammatic presentation of the <span onClick={() => setShowPdf(!showPdf)} style={{ color: "red", cursor: "pointer", textDecoration: "none" }}>standards development process</span>.
        </p>
      </section>

      {/* === PDF Inline Viewer === */}
      {showPdf && (
        <div className="pdf-viewer">
          <iframe
            src="/files/Standards development process.pdf"
            title="Standards Development Process"
            width="100%"
            height="800px"
            style={{ border: "1px solid #ccc", borderRadius: "8px" }}
          />
        </div>
      )}

      {/* === Popup Modal === */}
      {popup.show && (
        <div className="popup-overlay">
          <div className="popup">
            <button className="close-btn" onClick={closePopup}>×</button>
            <h2 className="popup-heading">{content.heading}</h2>
            <div className="popup-content">
              {content.body.split("\n").map((line, i) => <p key={i}>{line}</p>)}
            </div>
          </div>
        </div>
      )}

      {/* === Inline CSS === */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; }
        .about-header {
          background-image: url(${pictureOne});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }
        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          border-radius: 8px;
        }
        .page-title { font-size: 2.5rem; font-weight: bold; }
        .subtitle { margin-top: 10px; font-size: 1rem; }
        .what-section { padding: 50px 80px; font-size: 1rem; line-height: 1.6; }
        .what-section ul { margin-left: 20px; margin-bottom: 20px; }
        .what-section li { margin-bottom: 10px; }

        /* PDF viewer */
        .pdf-viewer { padding: 30px 80px; }

        /* Popup styles */
        .popup-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          backdrop-filter: blur(4px);
          background: rgba(0,0,0,0.4);
          display: flex; justify-content: center; align-items: center;
          z-index: 1000;
          animation: fadeIn 0.3s ease;
        }
        .popup {
          background: #fff;
          width: 700px;
          max-width: 95%;
          border-radius: 12px;
          padding: 25px 30px;
          position: relative;
          max-height: 85vh;
          overflow-y: auto;
          box-shadow: 0 8px 20px rgba(0,0,0,0.25);
          animation: slideIn 0.3s ease;
        }
        .popup-heading { font-weight: bold; font-size: 1.5rem; margin-bottom: 15px; }
        .close-btn { position: absolute; top: 15px; right: 15px; background: none; border: none; font-size: 1.8rem; cursor: pointer; }
        .popup-content p { margin-bottom: 12px; line-height: 1.6; }

        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideIn { from { transform: translateY(-20px); } to { transform: translateY(0); } }
      `}</style>
    </div>
  );
};

export default StandardsServices;
